var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMore = function SvgMore(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00033 5.33268C8.73366 5.33268 9.33366 4.73268 9.33366 3.99935C9.33366 3.26602 8.73366 2.66602 8.00033 2.66602C7.26699 2.66602 6.66699 3.26602 6.66699 3.99935C6.66699 4.73268 7.26699 5.33268 8.00033 5.33268ZM8.00033 6.66602C7.26699 6.66602 6.66699 7.26602 6.66699 7.99935C6.66699 8.73268 7.26699 9.33268 8.00033 9.33268C8.73366 9.33268 9.33366 8.73268 9.33366 7.99935C9.33366 7.26602 8.73366 6.66602 8.00033 6.66602ZM6.66699 11.9993C6.66699 11.266 7.26699 10.666 8.00033 10.666C8.73366 10.666 9.33366 11.266 9.33366 11.9993C9.33366 12.7327 8.73366 13.3327 8.00033 13.3327C7.26699 13.3327 6.66699 12.7327 6.66699 11.9993Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMore, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/more.01fd416c.svg";
export { ForwardRef as ReactComponent };